const getDefault = () => {
    return {
        loading: false,
        // nickname: "",
        // avatar: "",
    };
};

const state = getDefault();

const mutations = {
    SHOW_LOADING: (state, data) =>{
        state.loading = true
    },

    HIDE_LOADING:(state, data) =>{
        state.loading = false
    }
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
